import React from "react";
import { ModalHeader } from "reactstrap";

type Props = {
    title: string;
    onClose: () => void;
};

const TITLE_STYLE: React.CSSProperties = {
    fontFamily: "Segoe UI Semibold",
    color: "#2b2828",
    fontSize: "20px",
};

export function AlertModalHeader({ title, onClose }: Props) {
    return (
        <ModalHeader className="text-capitalize" toggle={onClose}>
            <span className="text-uppercase" style={TITLE_STYLE}>
                {title}
            </span>
        </ModalHeader>
    );
}
